<template>
  <div>
    <transition name="el-zoom-in-center">
      <div class="pop" v-show="status">
        <dv-border-box-1 class="popbox1">
          <i class="el-icon-circle-close" @click="close"></i>
          <div class="radioGroup">
            <slot name="tab"></slot>
          </div>
          <div class="list">
            <el-card>
              <div v-for="o in 4" :key="o" class="text item">
                {{ "列表内容 " + o }}
              </div>
            </el-card>
          </div>
          <div class="pagebox">
            <slot name="FY"></slot>
          </div>
        </dv-border-box-1>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Pageination",
  props: {
    status: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      css: "",
    };
  },

  computed: {},

  methods: {
    //   关闭
    close() {
      this.$emit("close");
    },
  },

  watch: {
    //   status(newv,oldv){
    //       if()
    //   }
  },
};
</script>

<style lang="scss" scoped>
.pop {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;

  .popbox1 {
    width: 765px;
    height: 480px;

    .el-icon-circle-close {
      color: #188ad7;
      font-size: 30px;
      position: absolute;
      top: 15px;
      right: 15px;
      cursor: pointer;
    }

    .radioGroup {
      width: 100%;
      display: flex;
      justify-content: center;
      padding-top: 30px;
      .el-radio-button__inner {
        background: transparent;
        border-color: #188ad7;
        color: #fff;
      }
    }

    .list {
      padding: 0 20px;
      .el-card {
        background: transparent;
        border: none;
        color: #fff;
      }
    }

    .pagebox {
      padding: 0 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>